import dataService from '../../../app.service'
import entityService from '../../../services/entity.service'
import logService from '../../../services/log.service'

const getAPIData = ({ commit, state }, slug) => {
  if (slug.type === 'entity') {
    return entityService
      .getEntityData(slug.key)
      .then(page => {
        commit('PAGE_API_UPDATED', { slug: slug, content: page })
      })
      .catch(error => {
        logService.log(error)
      })
  } else if (slug.type === 'sources') {
    if (!slug.key) {
      return commit('PAGE_API_UPDATED', { slug: slug, content: {} })
    } else {
      return entityService
        .getLatestEntityData(slug.kind, slug.key, slug.token)
        .then(page => {
          commit('PAGE_API_UPDATED', { slug: slug, content: page })
        })
        .catch(error => {
          commit('PAGE_API_UPDATED', { slug: slug, content: { _id: slug.key } })
          logService.log(error)
        })
    }
  } else {
    return dataService
      .getData(slug)
      .then(page => {
        commit('PAGE_API_UPDATED', { slug: slug, content: page })
      })
      .catch(error => {
        logService.log(error)
      })
  }
}

export { getAPIData }
